<mat-progress-bar class="loading-bar" *ngIf="loadingState | async" color="accent" mode="indeterminate"></mat-progress-bar>



// WEBPACK FOOTER //
// /home/markush/Projects/fieldsale-wingman-client/src/app/shared/components/loading-bar/loading-bar.component.html